enum Step {
	Login = "Login",
	DeliveryAddress = "DeliveryAddress",
	DeliveryOptions = "DeliveryOptions",
	PaymentDetails= "PaymentDetails",
	CompleteOrder = "CompleteOrder"
}

export default Step;
